import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PlansService } from './plans.service';

@NgModule({
  imports: [CommonModule],
  providers: [PlansService, provideHttpClient(withInterceptorsFromDi())]
})
export class PlansModule {}
